
Monet.UI = Monet.UI || {};

Monet.UI.LayoutGenerator = function (layout) {

    this.root = document.createDocumentFragment();

    this.layout = layout || {};

    this.setAttributes = function (el, attributes) {
        if (attributes) {
            for (var key in attributes) {
                el.setAttribute(key, attributes[key]);
            }
        }
    };

    this.generateItem = function (item) {
        var element = document.createElement(item.tag || "div");
        this.setAttributes(element, item.attributes);

        if (item.beforeHtml) {
            element.innerHTML = item.beforeHtml;
        }

        this.generateItems(element, item.items);

        if (item.html) {
            element.textContent = item.html;
        }
        return element;
    };

    this.generateItems = function (el, items) {
        if (items && items.length) {
            items.map(this.generateItem, this)
                .forEach(el.appendChild, el);
        }
    };

    this.render = function () {

        if (this.layout.tag) {
            this.root = document.createElement(this.layout.tag);
        }

        this.generateItems(this.root, this.layout.items);

        return this.root;

    };

};